export enum CommonErrorMessages {
	unknownResponse = 'Unknown server response',
}

export enum AuthErrorMessages {
	noLogin = 'User is not authenticated yet. Please, login first',
}
